<template>
    <v-app :style="backgroundDiv">
        <v-app-bar v-if="isShow" app color="#F8F8F8" elevation="0">
            <v-toolbar-title>
                <router-link :to="jump" style="color: white; text-decoration: none">
                    <v-row>
                        <v-col cols="10" lg="12">
                            <v-img src="./assets/logo.png"></v-img>
                        </v-col>
                    </v-row>
                </router-link>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-show="!$store.state.landing" text @click="$router.push({path: '/login'})">
                <v-icon>mdi-account</v-icon>
                登录
            </v-btn>
            <v-btn v-show="!$store.state.landing" text @click="$router.push({path: '/regist'})">
                <v-icon>mdi-account-plus</v-icon>
                注册
            </v-btn>
            {{$store.state.webUser.name}}
            <v-menu offset-y open-on-hover>
                <template v-slot:activator="{ on }">
                    <v-btn
                            v-show="$store.state.landing"
                            text
                            v-on="on">
                        <v-icon>mdi-account</v-icon>
                        用户中心
                        <!--                        {{$store.state.webUser.accountName}}-->
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="$router.push({path: '/myapply'})">
                        <v-icon>mdi-clipboard-text</v-icon>
                        <v-list-item-title>
                            我的申请
                        </v-list-item-title>
                    </v-list-item>
                    <!--<v-list-item @click="$router.push({path: '/myreport'})">-->
                        <!--<v-icon>mdi-clipboard-text</v-icon>-->
                        <!--<v-list-item-title>-->
                            <!--检测报告-->
                        <!--</v-list-item-title>-->
                    <!--</v-list-item>-->
                    <!--                    <v-list-item @click="$router.push({path: '/myappointment'})">-->
                    <!--                        <v-icon>mdi-clipboard-text</v-icon>-->
                    <!--                        <v-list-item-title>-->
                    <!--                            我的预约-->
                    <!--                        </v-list-item-title>-->
                    <!--                    </v-list-item>-->
                    <!--<v-list-item @click="$router.push({path: '/mytransfusionfeedback'})">-->
                        <!--<v-icon>mdi-clipboard-text</v-icon>-->
                        <!--<v-list-item-title>-->
                            <!--我的反馈-->
                        <!--</v-list-item-title>-->
                    <!--</v-list-item>-->
                    <!--<v-list-item @click="$router.push({path: '/mychargebill'})">-->
                        <!--<v-icon>mdi-clipboard-text</v-icon>-->
                        <!--<v-list-item-title>-->
                            <!--检测交费-->
                        <!--</v-list-item-title>-->
                    <!--</v-list-item>-->
                    <!--<v-list-item @click="$router.push({path: '/mytransfusionreaction'})">-->
                        <!--<v-icon>mdi-clipboard-text</v-icon>-->
                        <!--<v-list-item-title>-->
                            <!--输血反馈-->
                        <!--</v-list-item-title>-->
                    <!--</v-list-item>-->
                    <!--<v-list-item-->
                            <!--v-if="$store.state.webUser.level > 1"-->
                            <!--@click="$router.push({path: '/usermanage'})">-->
                        <!--<v-icon>mdi-account</v-icon>-->
                        <!--<v-list-item-title>-->
                            <!--用户管理-->
                        <!--</v-list-item-title>-->
                    <!--</v-list-item>-->
                    <!--<v-list-item @click="$router.push({path: '/edit'})">-->
                        <!--<v-icon>mdi-account-edit</v-icon>-->
                        <!--<v-list-item-title>-->
                            <!--修改资料-->
                        <!--</v-list-item-title>-->
                    <!--</v-list-item>-->
                    <v-list-item @click="logout">
                        <v-icon>mdi-logout</v-icon>
                        <v-list-item-title>
                            退出登录
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <!--            <v-btn v-show="$store.state.landing" text @click="logout">-->
            <!--                <v-icon>mdi-logout</v-icon>-->
            <!--                退出登录-->
            <!--            </v-btn>-->
        </v-app-bar>
        <v-content>
            <v-container>
                <router-view v-if="isRouterAlive"></router-view>
            </v-container>
        </v-content>
        <v-footer padless light color='#F8F8F8'>
            <v-col class="text-right v-size--small" align >
                <div style="font-size: 2.5mm">{{this.$version}}</div>
            </v-col>
        </v-footer>
    </v-app>
</template>

<script>

    export default {
        name: 'App',

        provide() {
            return {
                reload: this.reload
            }
        },

        components: {},

        data: () => ({
            isRouterAlive: true,
            isShow: (location.hash.indexOf("paternitytestformobile") === -1 && location.hash.indexOf("plateletreceipt") === -1 && location.hash.indexOf("marrowreceipt") === -1 && location.hash.indexOf("samplereceipt") === -1),
            jump: location.hash.indexOf("paternitytestformobile") === -1 ? '/' : '/paternitytestformobile',
            backgroundDiv: {

                backgroundColor: '#F8F8F8',

                // backgroundImage: 'url(' + require('./assets/bg.png') + ')',

                // backgroundRepeat: 'no-repeat',

                // backgroundSize: '100% 100%'

            },
        }),

        mounted() {
            // if (sessionStorage.length > 0) {
            //     this.$store.commit('setLanding', true);
            // }
            this.$axios.get('/unicorn/inspect').then((response) => {
                if (response.data.success) {
                    this.$store.commit('setLanding', true);
                    this.$store.commit('setWebUser', response.data.data);
                    sessionStorage.setItem("phoneNumber", response.data.data.phoneNumber);
                }
            }).catch(() => {
                this.$snackbar.info('连接服务器失败');
            });
        },

        methods: {
            logout() {
                this.$axios.get('/unicorn/webapp/logout').then((response) => {
                    if (response.data.success) {
                        sessionStorage.clear();
                        let me = this;
                        this.$snackbar.info(response.data.content);
                        me.$store.commit('setLanding', false);
                        me.$store.commit('clearWebUser');
                        me.$router.push({path: '/'});
                        this.overlay = false;
                    } else {
                        this.$snackbar.info(response.data.content);
                    }
                }).catch(() => {
                    this.$snackbar.info('连接服务器失败');
                });
            },
            reload() {
                this.isRouterAlive = false;
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            }
        }
    };
</script>
